import React, {Fragment, useEffect, useState} from 'react';
import {Col, Row} from "react-bootstrap";
import IconArrowLeft from "../../../assets/icon/IconArrowLeft";
import {useSelector} from "react-redux";
import {selectLang} from "../../../store/reducers/main/main";
import {Translate} from "../../../lang/lang";
import {useNavigate} from "react-router-dom";
import IconButton from "../../../components/IconButton";
import UploadContractorsListToExcel from "./UploadContractorsListToExcel";
import AddContractor from "../../../components/contractor/AddContractor";
import IconFilter from "../../../assets/icon/IconFilter";
import IconStroke from "../../../assets/icon/IconStroke";
import IconCaretDown from "../../../assets/icon/IconCaretDown";
import ContractorDataTableFilter from "./ContractorDataTableFilter";
import {scrollEvent} from "../../../helpers/scrollEvent";

const ItemDataTableHeader = ({
                                 currency,
                                 setSelectedCurrency,
                                 selectedCurrency,
                                 selectedRowIds,
                                 sort,
                                 setSort,
                                 sortByDesc,
                                 setSortByDesc,
                                 page,
                                 setFilter,
                                 data
                             }) => {

    const lang = useSelector(selectLang);
    const t = Translate;

    const navigate = useNavigate()

    const selectedContractors = Object?.keys(selectedRowIds)?.reduce((result, selectedIndex) => {
        if (page && page[selectedIndex])
            result.push(page[selectedIndex]?.original);
        return result;
    }, []);


    const [isOpenFilterCollapse, setIsOpenFilterCollapse] = useState(false);


    const [showBindContractorLabelModal, setShowBindContractorLabelModal] = useState(false)


    useEffect(() => {
        window.addEventListener('scroll', () => scrollEvent('warehouse-contractor-data-table-header'))
        return () => window.removeEventListener('scroll', () => scrollEvent('warehouse-contractor-data-table-header'))
    }, []);

    return (
        <Fragment>
            <Row id={'warehouse-contractor-data-table-header'}
                 className="flex-between-center align-items-center my-3 position-sticky z-index-1"
                 style={{top: '4rem'}}>
                <Col cols={'auto'} className={'d-flex gap-3'}>
                    <button onClick={() => navigate(-1)} className={'main-text btn-back'}
                            style={{width: 35, height: 35}}>
                        <IconArrowLeft/>
                    </button>
                    <div>
                        <h5 className="fs-8 mb-0 text-nowrap py-2 py-xl-0">{t(lang, "warehouse.operation.item.common.contractor_list")}</h5>
                        <span className={'second-text fs-9'}>{t(lang, 'items.common.warehouse')}</span>
                    </div>
                </Col>
                <Col xs={"auto"} className={'d-flex justify-content-end gap-2'}>

                    <UploadContractorsListToExcel data={selectedContractors.length > 0 ? selectedContractors : data}/>

                    <IconButton
                        onClick={() => setIsOpenFilterCollapse(!isOpenFilterCollapse)}
                        className="btn-davr ps-2 pe-1 py-0 bg-white text-dark gap-2"
                    >
                        <div className={'d-flex align-items-center'}>
                            <IconFilter/>
                            <span
                                className="d-none d-sm-inline-block ms-1 fs-8 text-nowrap fs-md-9">{t(lang, "roaming.invoices.table_header.filter")}</span>
                        </div>
                        <div className={'d-flex justify-content-between gap-2'}>
                            <IconStroke/>
                            <IconCaretDown/>
                        </div>
                    </IconButton>

                    {/*Объединить*/}
                    {/*<IconButton*/}
                    {/*    variant='phoenix-warning'*/}
                    {/*    size="sm"*/}
                    {/*    as={'div'}*/}
                    {/*    icon={''}*/}
                    {/*    className={'btn-davr bg-white text-dark d-flex gap-2'}*/}
                    {/*    iconClassName={"text-primary-davr fs-8"}*/}
                    {/*    onClick={() => setShowBindContractorLabelModal(true)}*/}
                    {/*>*/}
                    {/*    <span*/}
                    {/*        className="d-none d-sm-inline-block">{selectedContractors.length > 0 ? t(lang, "crm.contractor.mass_bind.label.button") : t(lang, "crm.contractor.bind.label.button")}</span>*/}
                    {/*</IconButton>*/}

                    <AddContractor/>
                </Col>
                <Col sm={12}>
                    <ContractorDataTableFilter isOpenFilterCollapse={isOpenFilterCollapse}
                                               setSelectedCurrency={setSelectedCurrency}
                                               selectedCurrency={selectedCurrency}
                                               setSortByDesc={setSortByDesc}
                                               sortByDesc={sortByDesc}
                                               setFilter={setFilter}
                                               currency={currency}
                                               setSort={setSort}
                                               sort={sort}
                    />
                </Col>
            </Row>
            {/*{selectedContractors.length > 0 ? <MassBindLabelsToContractorModal show={showBindContractorLabelModal}*/}
            {/*                                                                   contractorIds={selectedContractors?.map(contractor => contractor.id)}*/}
            {/*                                                                   setShow={setShowBindContractorLabelModal}/> :*/}
            {/*    <BindLabelsToContractorModal show={showBindContractorLabelModal}*/}
            {/*                                 setShow={setShowBindContractorLabelModal}/>}*/}
        </Fragment>
    );
};

export default ItemDataTableHeader;
